export default "__VITE_ASSET__58f08f15__"